import React from "react";
import LazyLoad from "react-lazyload";
import Kelly from "../finalistsheadshot/kelly.webp";
import Ameya from "../finalistsheadshot/id.webp";
import Ameya2 from "../finalistsheadshot/Ameyatwo.webp";
import Amber from "../finalistsheadshot/amber.webp";
import Vishnu from "../finalistsheadshot/Vishnu.webp";
import Devesh from "../finalistsheadshot/Devesh.webp";
import Sammit from "../finalistsheadshot/Sammit.webp";
import Tanvi from "../finalistsheadshot/Tanvi.webp";
import Cyrus from "../finalistsheadshot/Ghane.webp";
import Akhil from "../finalistsheadshot/Akhil.webp";
import Yanrui from "../finalistsheadshot/Yarnui.webp";
import Colin from "../finalistsheadshot/Colinding.webp";
import Pranava from "../finalistsheadshot/Prananva.webp";
import Shreeya from "../finalistsheadshot/Shreeya.webp";
import Elie from "../finalistsheadshot/Elie.webp";
import Haorui from "../finalistsheadshot/HAORUIZHANG.webp";
import JiaChen from "../finalistsheadshot/JiaChenQu.webp";
import Jinghan from "../finalistsheadshot/JINGHANGAO.webp";
import Leqi from "../finalistsheadshot/LEQICAI.webp";
import Shunyu from "../finalistsheadshot/ShunyuHuang.webp";
import Yichen from "../finalistsheadshot/YICHENGLIU.webp";

const finalists = [
  { id: 1, name: "Kelly Lock", image: Kelly },
  { id: 2, name: "Ameya Kharade", image: Ameya2 },
  { id: 3, name: "Amber Chow", image: Amber },
  { id: 4, name: "Vishnu G Vijay", image: Vishnu },
  { id: 5, name: "Devesh Aggarwal", image: Devesh },
  { id: 6, name: "Sammit Prem Chidambaram", image: Sammit },
  { id: 7, name: "Tanvi Nare", image: Tanvi },
  { id: 8, name: "Cyrus Ghane", image: Cyrus },
  { id: 9, name: "Ameya Shirguppe", image: Ameya },
  { id: 10, name: "Akhil Yalamanchili", image: Akhil },
  { id: 11, name: "Yanrui Li", image: Yanrui },
  { id: 12, name: "Colin Yuanjie Ding", image: Colin },
  { id: 13, name: "Pranava Senathipathi Kumar", image: Pranava },
  { id: 14, name: "Shreeya Rao Lalam", image: Shreeya },
  { id: 15, name: "Elie Ciril Jr.", image: Elie },
  { id: 16, name: "Haorui Zhang", image: Haorui },
  { id: 17, name: "Jia Chen Qu", image: JiaChen },
  { id: 18, name: "Jinghan Gao", image: Jinghan },
  { id: 19, name: "Leqi Cai", image: Leqi },
  { id: 20, name: "Shunyu Huang", image: Shunyu },
  { id: 21, name: "Yichen Liu", image: Yichen },
];

// Finalist card component
const FinalistCard = ({ image, name }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
      border: "1px solid #e8eef3",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-4px)";
      e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 77, 153, 0.1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.06)";
    }}
  >
    <div
      style={{
        position: "relative",
        paddingTop: "120%",
        backgroundColor: "#f8f9fa",
      }}
    >
      <LazyLoad once offset={100}>
        <img
          src={image}
          alt={name}
          className="no-invert-image-partners-css"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </LazyLoad>
    </div>
    <div style={{ padding: "16px", textAlign: "center" }}>
      <h3
        style={{
          fontSize: "0.95rem",
          fontWeight: "600",
          color: "#1a1a2e",
          margin: 0,
        }}
      >
        {name}
      </h3>
    </div>
  </div>
);

function WinnersFour() {
  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: "40px" }}>
        <span
          style={{
            display: "inline-block",
            padding: "6px 14px",
            borderRadius: "6px",
            backgroundColor: "rgba(0, 77, 153, 0.08)",
            color: "#004d99",
            fontSize: "0.85rem",
            fontWeight: "600",
            marginBottom: "16px",
          }}
        >
          May 5, 2025
        </span>
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "16px",
          }}
        >
          2025 IRO Finalists
        </h2>
        <p
          style={{
            fontSize: "1.05rem",
            color: "#555",
            lineHeight: "1.7",
            marginBottom: "16px",
          }}
        >
          <strong>
            Congratulations to the finalists of the 2025 International Research
            Olympiad.
          </strong>{" "}
          After several stages of evaluation, the top 21 scorers have been
          announced as finalists.
        </p>
      </div>

      {/* Quote Card */}
      <div
        style={{
          background: "#f8f9fa",
          borderRadius: "16px",
          padding: "32px",
          marginBottom: "50px",
          borderLeft: "4px solid #004d99",
        }}
      >
        <p
          style={{
            fontSize: "1rem",
            color: "#555",
            lineHeight: "1.8",
            fontStyle: "italic",
            marginBottom: "16px",
          }}
        >
          "We stand committed to making this community into a close, innovative,
          welcoming, and supportive society around student research aspirations.
          On behalf of the trustees and advisors of the 2025 International
          Research Olympiad, I am pleased to announce that you have been
          selected as a finalist in this competition. It started at over 3,000
          individuals, and after several rounds of rigorous evaluation, your
          research abilities stood out as among the best in the world."
        </p>
        <p
          style={{
            fontSize: "0.9rem",
            color: "#666",
            fontStyle: "italic",
            marginBottom: "16px",
          }}
        >
          "As someone who was involved in the final selection process based on
          the Oral Examination and other test scores, I can confidently say that
          your oral presentation was truly impressive, and it is clear that you
          have put a tremendous amount of effort and skill into your work. Each
          and every one of you brought a unique flavor to research— a skill that
          our scientific Board of Advisors encouraged us to seek out through
          this contest."
        </p>
        <p
          style={{
            fontSize: "0.9rem",
            color: "#666",
            fontStyle: "italic",
            marginBottom: "16px",
          }}
        >
          "You will each receive a personalized email from a member of the IRO
          Director or Executive team who will guide you through the finalist
          process — a 1:1 line of reliable, personal communication. This
          individual will provide more details about your selection and the
          exciting next steps."
        </p>
        <p
          style={{
            fontSize: "0.9rem",
            color: "#666",
            fontStyle: "italic",
            marginBottom: "16px",
          }}
        >
          "Personally, I want to take this moment to congratulate you on this
          achievement. As a current student who has greatly benefited from
          research and STEM competitions, I genuinely understand the hard work,
          dedication, and sacrifice that goes into achieving such a high level
          of success. You should all be proud of yourselves for making it this
          far—and be prepared to have your ambitions and accomplishments
          skyrocket in the near future."
        </p>
        <p
          style={{
            fontSize: "0.9rem",
            color: "#666",
            fontStyle: "italic",
            marginBottom: "16px",
          }}
        >
          "The IRO finals experience has been meticulously crafted by myself and
          a team—a team that has extensive experience with science
          competitions—to optimize for the most fun and rewarding experience
          possible—along with the prestige that comes with placing in an
          international-level competition with over a thousand entries in its
          first year. Our goal is to make this the most memorable research event
          you'll ever attend."
        </p>
        <p
          style={{
            fontSize: "0.95rem",
            color: "#1a1a2e",
            fontWeight: "600",
            margin: 0,
          }}
        >
          — Rishab Jain, President & Chair of Student Board of Advisors
        </p>
      </div>

      {/* Finalists Description */}
      <p
        style={{
          fontSize: "1rem",
          color: "#555",
          lineHeight: "1.8",
          marginBottom: "40px",
          textAlign: "center",
          maxWidth: "800px",
          margin: "0 auto 40px auto",
        }}
      >
        The International Research Olympiad is a platform that strives to create
        and promote research culture among high school students. This is done by
        providing a variety of services, tools, and support that aim to
        streamline the research process. The IRO seeks to give students the
        opportunity to develop their research proficiency, learn new
        methodologies, and collaborate at an international scale.
      </p>

      {/* Finalists Grid */}
      <div style={{ marginBottom: "30px" }}>
        <h3
          style={{
            fontSize: "1.3rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "24px",
          }}
        >
          Meet the Finalists
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
            gap: "20px",
          }}
        >
          {finalists.map((finalist) => (
            <FinalistCard
              key={finalist.id}
              image={finalist.image}
              name={finalist.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default WinnersFour;
